import MarketingUpdateEmail from './MarketingUpdateEmail';

export default MarketingUpdateEmail;
